/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelViewEdiOrder.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/view-edi-order";

export class AutogenModelViewEdiOrder<RowType extends ModelRow> extends Endpoint<RowType, RowViewEdiOrderFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowViewEdiOrder extends ModelRow<RowViewEdiOrderFields> {
	constructor(values?: Partial<RowViewEdiOrderFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowViewEdiOrderFields {
	agency_id: string;
	agent_payee_id: string;
	alt_partner_id: string;
	app_type: string;
	auto_send_reply: string;
	autorate_status: string;
	bill_date: Date;
	bill_distance: number;
	bill_distance_um: string;
	billing_empty_distance: number;
	billing_empty_distance_um: string;
	billing_loaded_distance: number;
	billing_loaded_distance_um: string;
	billing_user_id: string;
	blnum: string;
	bol_received: string;
	booking_no: string;
	booking_number: string;
	bplant: string;
	cancelled_order: string;
	car_address: string;
	car_city: string;
	car_code: string;
	car_code_qualifier: string;
	car_name: string;
	car_pay_method: string;
	car_phone_number: string;
	car_pro_nbr: string;
	car_state: string;
	car_trip_lease: string;
	car_zip_code: string;
	carrier_id: string;
	carrier_tractor: string;
	carrier_trailer: string;
	changed_order: string;
	collection_method: string;
	commitment_id: string;
	commodity: string;
	"commodity.company_id": string;
	"commodity.cubic_units": number;
	"commodity.cubic_units_is_per_piece": string;
	"commodity.descr": string;
	"commodity.dunnage_is_per_piece": string;
	"commodity.dunnage_weight": number;
	"commodity.fgi_value": number;
	"commodity.fgi_value_c": string;
	"commodity.fgi_value_d": Date;
	"commodity.fgi_value_is_per_piece": string;
	"commodity.fgi_value_n": number;
	"commodity.fgi_value_r": number;
	"commodity.handling_units": number;
	"commodity.handling_units_is_per_piece": string;
	"commodity.hazmat": string;
	"commodity.hazmat_class_code": string;
	"commodity.hazmat_contact": string;
	"commodity.hazmat_erg_number": string;
	"commodity.hazmat_is_residue": string;
	"commodity.hazmat_number": string;
	"commodity.hazmat_packing_group": string;
	"commodity.hazmat_phone": string;
	"commodity.hazmat_proper_shipname": string;
	"commodity.hazmat_qty_code": string;
	"commodity.hazmat_ref_type_code": string;
	"commodity.hazmat_subclass_code": string;
	"commodity.height": number;
	"commodity.id": string;
	"commodity.intelliset": string;
	"commodity.is_hazmat": string;
	"commodity.is_poison": string;
	"commodity.length": number;
	"commodity.nmfc_class_code": string;
	"commodity.nmfc_code": string;
	"commodity.optiset": string;
	"commodity.packaging_type_code": string;
	"commodity.placard_required": string;
	"commodity.poison_zone": string;
	"commodity.product_sku": string;
	"commodity.req_spots": number;
	"commodity.return_var": number;
	"commodity.return_var_um": string;
	"commodity.scan_unit_type": string;
	"commodity.seats": number;
	"commodity.seats_is_per_piece": string;
	"commodity.setpoint_temp": number;
	"commodity.setpoint_temp_um": string;
	"commodity.setpoint_var": number;
	"commodity.setpoint_var_um": string;
	"commodity.signoff_text": string;
	"commodity.spots_is_per_piece": string;
	"commodity.temperature_max": number;
	"commodity.temperature_max_um": string;
	"commodity.temperature_min": number;
	"commodity.temperature_min_um": string;
	"commodity.training_url": string;
	"commodity.type_code": string;
	"commodity.weight": number;
	"commodity.weight_is_per_piece": string;
	"commodity.weight_uom_type_code": string;
	"commodity.width": number;
	commodity_id: string;
	company_id: string;
	complete_document: string;
	cons_ediloc: string;
	consignee_ediloc: string;
	consignee_refno: string;
	consignee_stop_id: string;
	container_planned: string;
	container_type_id: string;
	copy_from_company: string;
	copy_from_order_id: string;
	create_date: Date;
	ctrl_party_id: string;
	cube: number;
	curr_movement_id: string;
	currency_iso_id: string;
	currency_type_id: string;
	cust_order_no: string;
	customer_ediloc: string;
	customer_id: string;
	default_match_id: string;
	dim_height: string;
	dim_length: string;
	dim_surcharge: number;
	dim_surcharge_c: string;
	dim_surcharge_d: Date;
	dim_surcharge_n: number;
	dim_surcharge_r: number;
	dim_width: string;
	direction: string;
	dispatcher_user_id: string;
	dray_del_date: Date;
	dray_del_pay: number;
	dray_del_pay_c: string;
	dray_del_pay_d: Date;
	dray_del_pay_n: number;
	dray_del_pay_r: number;
	dray_del_payee: string;
	dray_del_xfer_dt: Date;
	dray_pu_date: Date;
	dray_pu_pay: number;
	dray_pu_pay_c: string;
	dray_pu_pay_d: Date;
	dray_pu_pay_n: number;
	dray_pu_pay_r: number;
	dray_pu_payee: string;
	dray_pu_xfer_dt: Date;
	edi_commodity_id: string;
	edi_equip_type_id: string;
	edi_error: number;
	edi_order_type_id: string;
	edi_revenue_code: string;
	edi_seg_alloc_code: string;
	"edi_template.ack_required": string;
	"edi_template.app_receiver_code": string;
	"edi_template.app_receiver_id": string;
	"edi_template.app_sender_code": string;
	"edi_template.app_sender_id": string;
	"edi_template.authen_info": string;
	"edi_template.authen_info_qual": string;
	"edi_template.company_id": string;
	"edi_template.ctl_version": string;
	"edi_template.ctl_version_qual": string;
	"edi_template.descr": string;
	"edi_template.direction": string;
	"edi_template.ele_separator": number;
	"edi_template.end_of_line_1": number;
	"edi_template.end_of_line_2": number;
	"edi_template.filepath": string;
	"edi_template.format_type": string;
	"edi_template.functional_id": string;
	"edi_template.id": number;
	"edi_template.industry": string;
	"edi_template.is_multi_partner": string;
	"edi_template.name": string;
	"edi_template.parse_batch_number": string;
	"edi_template.parse_create_date": string;
	"edi_template.parse_create_datef": string;
	"edi_template.parse_fg_segment": string;
	"edi_template.parse_tran_ctrl_no": string;
	"edi_template.parse_tran_segment": string;
	"edi_template.receiver_id": string;
	"edi_template.receiver_qual": string;
	"edi_template.secur_info": string;
	"edi_template.secur_info_qual": string;
	"edi_template.sender_id": string;
	"edi_template.sender_qual": string;
	"edi_template.spec_footer_text": string;
	"edi_template.spec_header_text": string;
	"edi_template.spec_title": string;
	"edi_template.standard": string;
	"edi_template.subele_separator": number;
	"edi_template.tag_format_text": string;
	"edi_template.test_indicator": string;
	"edi_template.transaction_set": string;
	"edi_template.transaction_type": string;
	"edi_template.translation_method": string;
	"edi_template.update_date": Date;
	"edi_template.version": string;
	"ediorder_profile.ack_xmit_method": string;
	"ediorder_profile.agent_payee_id": string;
	"ediorder_profile.alt_partner_id": string;
	"ediorder_profile.apply_chassis_adds": string;
	"ediorder_profile.apply_container_adds": string;
	"ediorder_profile.apply_frt_adds": string;
	"ediorder_profile.apply_frt_chgs": string;
	"ediorder_profile.apply_frt_dels": string;
	"ediorder_profile.apply_hdr_adds": string;
	"ediorder_profile.apply_hdr_chgs": string;
	"ediorder_profile.apply_hdr_dels": string;
	"ediorder_profile.apply_move_chgs": string;
	"ediorder_profile.apply_note_adds": string;
	"ediorder_profile.apply_note_dels": string;
	"ediorder_profile.apply_oc_adds": string;
	"ediorder_profile.apply_oc_chgs": string;
	"ediorder_profile.apply_oc_dels": string;
	"ediorder_profile.apply_order_chgs": string;
	"ediorder_profile.apply_refno_adds": string;
	"ediorder_profile.apply_refno_chgs": string;
	"ediorder_profile.apply_refno_dels": string;
	"ediorder_profile.apply_stop_adds": string;
	"ediorder_profile.apply_stop_chgs": string;
	"ediorder_profile.apply_stop_dels": string;
	"ediorder_profile.auto_add_carrier": string;
	"ediorder_profile.auto_add_location": string;
	"ediorder_profile.auto_cancel": string;
	"ediorder_profile.auto_compare": string;
	"ediorder_profile.auto_compare_rt": string;
	"ediorder_profile.auto_create_edi_loc": string;
	"ediorder_profile.auto_create_order": string;
	"ediorder_profile.auto_create_reply": string;
	"ediorder_profile.auto_rate": string;
	"ediorder_profile.auto_send_reply": string;
	"ediorder_profile.auto_send_tender": string;
	"ediorder_profile.bl_updates_order": string;
	"ediorder_profile.carrier_id": string;
	"ediorder_profile.clear_old_changes": string;
	"ediorder_profile.commodity_id": string;
	"ediorder_profile.company_id": string;
	"ediorder_profile.compare_confirm": string;
	"ediorder_profile.compare_exis_stops": string;
	"ediorder_profile.compare_new_stops": string;
	"ediorder_profile.compare_update": string;
	"ediorder_profile.complete_document": string;
	"ediorder_profile.copy_from_company": string;
	"ediorder_profile.create_shipstatus": string;
	"ediorder_profile.currency_type_id": string;
	"ediorder_profile.days_to_retain": number;
	"ediorder_profile.decl_req_reason": string;
	"ediorder_profile.direction": string;
	"ediorder_profile.document_compared": string;
	"ediorder_profile.dup_cutoff_days": number;
	"ediorder_profile.edi_comm_id": number;
	"ediorder_profile.enable_load_analyzer": string;
	"ediorder_profile.enable_tl_wizard": string;
	"ediorder_profile.enf_batch_cont_204": string;
	"ediorder_profile.enf_batch_cont_990": string;
	"ediorder_profile.enf_batch_cont_997": string;
	"ediorder_profile.equipment_type_id": string;
	"ediorder_profile.fa_threshold": number;
	"ediorder_profile.filename": string;
	"ediorder_profile.func_ack_filename": string;
	"ediorder_profile.func_ack_st02_frmt": string;
	"ediorder_profile.func_ack_tid": number;
	"ediorder_profile.func_altpartner_id": string;
	"ediorder_profile.func_comm_id": number;
	"ediorder_profile.func_next_batch": number;
	"ediorder_profile.func_partner_id": string;
	"ediorder_profile.func_use_m_batch": string;
	"ediorder_profile.func_version": string;
	"ediorder_profile.id": string;
	"ediorder_profile.ignore_map_errors": string;
	"ediorder_profile.ignore_old_changes": string;
	"ediorder_profile.intercompany": string;
	"ediorder_profile.lock_miles": string;
	"ediorder_profile.next_batch": number;
	"ediorder_profile.notes": string;
	"ediorder_profile.old_changes_reply": string;
	"ediorder_profile.order_type_id": string;
	"ediorder_profile.override_reply": string;
	"ediorder_profile.override_warning": string;
	"ediorder_profile.partner_code_car": string;
	"ediorder_profile.partner_code_loc": string;
	"ediorder_profile.partner_id": string;
	"ediorder_profile.partner_name": string;
	"ediorder_profile.partner_status": string;
	"ediorder_profile.payee_expense_glid": string;
	"ediorder_profile.payee_pay_freq": string;
	"ediorder_profile.payee_pay_method": string;
	"ediorder_profile.pieces_info": string;
	"ediorder_profile.primary_agency": string;
	"ediorder_profile.process_as": string;
	"ediorder_profile.process_priority": number;
	"ediorder_profile.prompt_xref_edi_loc": string;
	"ediorder_profile.rate_info": string;
	"ediorder_profile.rbd_timezone_id": string;
	"ediorder_profile.remove_file": string;
	"ediorder_profile.reply_altpartnerid": string;
	"ediorder_profile.reply_comm_id": number;
	"ediorder_profile.reply_filename": string;
	"ediorder_profile.reply_next_batch": number;
	"ediorder_profile.reply_partner_id": string;
	"ediorder_profile.reply_st02_format": string;
	"ediorder_profile.reply_tid": number;
	"ediorder_profile.reply_use_m_batch": string;
	"ediorder_profile.reply_version": string;
	"ediorder_profile.reply_xmit_method": string;
	"ediorder_profile.require_loc_code": string;
	"ediorder_profile.requires_reply": string;
	"ediorder_profile.respond_within": number;
	"ediorder_profile.revenue_code_id": string;
	"ediorder_profile.rply_rquired_cance": string;
	"ediorder_profile.rply_rquired_chang": string;
	"ediorder_profile.rply_rquired_orig": string;
	"ediorder_profile.scac": string;
	"ediorder_profile.seg_alloc_code": string;
	"ediorder_profile.send_func_ack": string;
	"ediorder_profile.send_to_company": string;
	"ediorder_profile.special_processing": string;
	"ediorder_profile.st02_format": string;
	"ediorder_profile.template_id": number;
	"ediorder_profile.transaction_set": string;
	"ediorder_profile.transmit_method": string;
	"ediorder_profile.use_master_batch": string;
	"ediorder_profile.version": string;
	"ediorder_profile.weight_info": string;
	"ediorder_profile.when_to_send_code": string;
	eir1_no: string;
	eir2_no: string;
	entered_user_id: string;
	equipment_type_id: string;
	est_tolls: number;
	est_tolls_c: string;
	est_tolls_d: Date;
	est_tolls_n: number;
	est_tolls_r: number;
	external_invoiceno: string;
	extra_deliveries: number;
	extra_pickups: number;
	fgp_uid: number;
	fleet_manager: string;
	forwd_location_id: string;
	free_days: number;
	freight_charge: number;
	freight_charge_c: string;
	freight_charge_d: Date;
	freight_charge_n: number;
	freight_charge_r: number;
	fuel_distance: number;
	fuel_distance_um: string;
	func_ack_batch: number;
	func_ack_id: string;
	func_ack_rec: string;
	func_ack_rec_date: Date;
	func_ack_received: string;
	func_ack_status: string;
	gs06_group_cntlno: string;
	gs_date_time: Date;
	hazmat: string;
	hazmat_code: string;
	high_value: string;
	hold_reason: string;
	id: string;
	ignore_map_errors: string;
	image_is_present: string;
	import_export: string;
	include_split_point: string;
	initial_purpose: string;
	intercompany: string;
	intercompany_key: string;
	invoice_recv_date: Date;
	is_asset_company: string;
	is_autorate_dist: string;
	is_billed: boolean;
	is_commodity_hazmat: boolean;
	is_container: string;
	is_dedicated: string;
	is_dray: string;
	is_local_mile: string;
	isa13_intr_cntlno: string;
	jag_carrier_id: string;
	jag_cost_rate_id: number;
	ldport_location_id: string;
	linear_feet_avail: number;
	load_date: Date;
	lock_miles: string;
	ltl: string;
	manifest_id: string;
	missing_xref_label: string;
	move_status: string;
	no_display: string;
	nte_lp_num: string;
	nte_lp_qual: string;
	on_hold: string;
	operational_status: string;
	operations_user: string;
	order_cancelled: string;
	order_compared: string;
	order_id: string;
	order_length: number;
	order_mode: string;
	order_status: string;
	order_type_id: string;
	order_value: number;
	order_value_c: string;
	order_value_d: Date;
	order_value_n: number;
	order_value_r: number;
	ordered_by: string;
	ordered_date: Date;
	ordered_method: string;
	orig_dest_rate_id: string;
	original_order: string;
	other_pay_total: number;
	other_pay_total_c: string;
	other_pay_total_d: Date;
	other_pay_total_n: number;
	other_pay_total_r: number;
	otherchargetotal: number;
	otherchargetotal_c: string;
	otherchargetotal_d: Date;
	otherchargetotal_n: number;
	otherchargetotal_r: number;
	override_pay_amt: number;
	override_pay_amt_c: string;
	override_pay_amt_d: Date;
	override_pay_amt_n: number;
	override_pay_amt_r: number;
	override_pay_rate: number;
	override_pay_units: number;
	override_type: string;
	override_units: number;
	pallets_how_many: number;
	pallets_required: string;
	partner_id: string;
	partner_name: string;
	pay_gross: number;
	pay_gross_c: string;
	pay_gross_d: Date;
	pay_gross_n: number;
	pay_gross_r: number;
	pick_up_no: string;
	pieces: number;
	placard_required: string;
	planning_comment: string;
	port_of_discharge: string;
	preload_trailer_id: string;
	preloaded: string;
	purpose: string;
	purpose_type: string;
	rate: number;
	rate_currency_type: string;
	rate_id: number;
	rate_min_weight: number;
	rate_min_weight_um: string;
	rate_type: string;
	rate_unit_desc: string;
	rate_units: number;
	rbd_timezone_id: string;
	ready_to_bill: string;
	ready_to_send: string;
	record_in_use: string;
	record_locked: string;
	recurring_order_id: string;
	reply_action: string;
	reply_altpartnerid: string;
	reply_batch_id: number;
	reply_created: string;
	reply_date: Date;
	reply_error: number;
	reply_error_descr: string;
	reply_gs_date_time: Date;
	reply_partner_id: string;
	reply_reason: string;
	reply_received: string;
	reply_received_ts: string;
	reply_remarks: string;
	reply_req_cancel: string;
	reply_req_change: string;
	reply_req_original: string;
	reply_st02: string;
	reply_tid: number;
	reply_trans_count: number;
	reply_transmitted: string;
	reply_user: string;
	reply_version: string;
	require_tracking: string;
	required_vendor: string;
	requires_reply_outbound: string;
	respond_by_date: Date;
	revenue_code_id: string;
	revenue_share_method: string;
	rf_entry_code_required: boolean;
	round_trip: string;
	sail_date: Date;
	scac: string;
	seal_number: string;
	seg_alloc_code: string;
	ship_status_to_edi: string;
	shipment_id: string;
	shipper_ediloc: string;
	shipper_stop_id: string;
	shipstatus2edi_dt: Date;
	show_equipment_type_options: boolean;
	ss_location_id: string;
	st02_trxset_cntlno: string;
	status: string;
	teams_required: string;
	temperature_max: number;
	temperature_max_um: string;
	temperature_min: number;
	temperature_min_um: string;
	temperature_um: string;
	tender_ignored: string;
	tender_status: string;
	total_charge: number;
	total_charge_c: string;
	total_charge_d: Date;
	total_charge_n: number;
	total_charge_r: number;
	total_pay: number;
	total_pay_c: string;
	total_pay_d: Date;
	total_pay_n: number;
	total_pay_r: number;
	tractor_type: string;
	trans_count: number;
	transaction_set: string;
	transit_warning_id: string;
	transmit_status: string;
	transmitted: string;
	ts_borrowing_company: string;
	ts_commodity: string;
	user_id: string;
	version: string;
	vessel: string;
	vessel_cutoff_date: Date;
	weight: number;
	weight_um: string;
	xferred2billing: string;
	xferred2billing_dt: Date;
	days_back: number;
}

